module.exports = __webpack_public_path__ + "../resources/img/ic_cancel.2470d0bb.svg";